import { Component, OnInit, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { egretAnimations } from "../../../../shared/animations/egret-animations";
import { TransactionService } from '../../../../shared/services/MyServices/transaction.service';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';
import { AppConfirmService } from '../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from '../../../../shared/services/app-loader/app-loader.service';
import { DataPassService } from '../../../../shared/services/MyServices/data-pass.service';
import { Page } from '../../../../../../src/app/shared/models/PaginationPage';
import { CommonService } from 'app/shared/services/MyServices/common.service';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SecureserviceService } from 'app/shared/services/MyServices/secureservice.service';

@Component({
  selector: 'app-salesenquiry',
  templateUrl: './salesenquiry.component.html',
  styleUrls: ['./salesenquiry.component.scss']
})

export class SalesenquiryComponent implements OnInit {
 page = new Page();
  public items: any[];
  temp = [];
  tableOffset: any;
  from_date: any;
  to_date: any;
  chassis_number: any;
  vc_number: any;
  lob: any;
  distributor_code: any;
  state: any;
  city: any;
  customer_type: any;
  customer_name: any;
  lead_id: any;
  opty_id: any;
  full_name: any;
  last_name: any;
  vehicle_application: any;
  source_of_contact: any;
  district: any;
  organization_name: any;
  mobile_no: any;
  isReset:boolean = false;
  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
  public getItemSub: Subscription;
  leaditems: any;
  oldSelectedValue: any;
  orderstatus: string[] = [
    'Request Accepted',
    'C0 (Prospecting)',
    'C1 (Quote Tendered)',
    'C2 (Adv. Received)',
    'C3 (Vehicle Delivered)',

    'Closed Lost at C0',
    'Closed Lost at C1',
    'Closed Lost at C2',
  ];
  optyStatus: string[] = [
  "UV-C0 (Prospecting)",
  "UV-C1 (Quote Tendered)",
  "UV-C2 (Adv. Received)",
  "UV-C3 (Vehicle Delivered)",
  "Closed Lost at UV-C0",
  "Closed Lost at UV-C1",
  "Closed Lost at UV-C2"
  ];
  selectedStatus: any;
  status: string;
  constructor(
    private loader: AppLoaderService, private commonservice: CommonService, private datepipe: DatePipe,private router: Router,private cdr: ChangeDetectorRef,private secureservice:SecureserviceService,
    private dialog: MatDialog) {
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.totalElements = 0;
    this.page.totalElementsPark = 0
  }
  RoleType: any;
  SessionData: any;
  isDealer: boolean = true;
  isPageUrlCheck: any;
  tab1: boolean = true; // Initially show Lead List 1
  tab2: boolean = false;
  Subtab1: boolean = true; // Initially show Lead List 1
  Subtab2: boolean = false;
  SubtabCat1: boolean = true; // Initially show Lead List 1
  SubtabCat2: boolean = false;
  filterFields: boolean = false;
  isRegional: boolean = true;
  showFilters = false;
  ngOnInit() {

    const ListInput: ListInput = {} as ListInput;
     ListInput.offset = 0*10;
     ListInput.limit = this.page.size;
     ListInput.mobile_number = "";
     ListInput.from_date ="";
     ListInput.to_date = "";
     ListInput.registration_number = "";
     this.tableOffset = 0;
     
     this.getospleadDataList(ListInput);
  }


toggleFilterDiv() {
  this.showFilters = !this.showFilters;
}

  filterValue:any={}
  handleFilters(filters) {
    this.filterValue = {};
    this.filterValue = filters
    this.tableOffset = 0;

    const ResponseData: inputData = {} as inputData;

    ResponseData.offset = 0 * 10;
    ResponseData.limit = this.page.size;
    ResponseData.mobile_number = filters.mobile || "";
    ResponseData.from_date = filters.fromDate || "";
    ResponseData.to_date = filters.toDate || "";
    ResponseData.registration_number = filters.registration_number || "";


    if (filters == "reset") {
      this.tableOffset = 0
      this.filterValue = {};
      this.refreshListing();
    }
    else {


      this.getospleadDataList(ResponseData);
    }

  }
  refreshListing() {
    this.isReset = true;
    setTimeout(() => {
      this.isReset = false;
    }, 300);
    this.filterValue = {};
    this.tableOffset = 0
    const ResponseData: inputData = {} as inputData;
    ResponseData.offset = 0 * 10;
    ResponseData.limit = this.page.size;
    ResponseData.mobile_number = "";
    ResponseData.from_date = "";
    ResponseData.to_date = "";
    ResponseData.registration_number = "";

    this.getospleadDataList(ResponseData);
  }


  setPage(pageInfo) {
    this.tableOffset = pageInfo.offset;
    this.page.pageNumber = pageInfo.offset;

    const ListInput: ListInput = {} as ListInput;

    ListInput.offset = (pageInfo.offset * 10);
    ListInput.limit = 10;
    ListInput.mobile_number = this.filterValue.mobile || "";
    ListInput.from_date = this.filterValue.fromDate || "";
    ListInput.to_date = this.filterValue.toDate || "";
    ListInput.registration_number = this.filterValue.registration_number || "";



    this.table.offset = 0;
    this.getospleadDataList(ListInput);

  }

    popupHandler() {
    this.filterFields = !this.filterFields;
  }
   getospleadDataList(ListInput) {
    this.loader.open();
    this.commonservice.SalesEnquiryList(ListInput)
      .subscribe(data => {
        if (data instanceof HttpErrorResponse) {
          this.loader.close();
          return;
        }
        if (data.success) {
          this.loader.close();
          this.page.totalElements = data.total_count;
          this.leaditems = this.temp = data.data;
        } else {
          // Error handling
          this.leaditems = [];
          Swal.fire(data.data.msg, 'Error')
          this.page.totalElements = 0;
          // this.page.size = 0;
          this.leaditems = this.temp = [];
          this.loader.close();
        }
      },
      (err) => {
        this.page.totalElements = 0;
        this.leaditems = [];
        this.loader.close();
      });
  }


  downloadAllLeadDataAndExcel(): void {
    this.loader.open();
    let offset = 0;
    const pageSize = 10; 
    const leadSource = 'osp';
    const allLeadItems: any[] = []; 
    const fetchData = (currentOffset: number) => {
      const ListInput = {
        offset: currentOffset*10,
        limit: pageSize,
        mobile_number: this.filterValue.mobile || "",
        from_date: this.filterValue.fromDate || "",
        to_date: this.filterValue.toDate || "",
        registration_number :this.filterValue.registration_number || ""

      };
  
      // setTimeout(() => {
        this.commonservice.SalesEnquiryList(ListInput).subscribe(
          data => {
            if (data instanceof HttpErrorResponse) {
              this.loader.close();
              Swal.fire('Error fetching data', 'Error');
              return;
            }
  
            if (data.success) {
              allLeadItems.push(...data.data);
            const  totalFetched = allLeadItems.length;
              const totalAvailable = data.total_count;
   
              if (totalFetched >= totalAvailable) {
                this.downloadExcel(allLeadItems);
                this.loader.close();
                return; 
              }
  
              fetchData(currentOffset + 1); 
            } else {
              this.loader.close();
              Swal.fire(data.data.msg, 'Error');
            }
          },
          err => {
            
            this.loader.close();
            Swal.fire('Error fetching data', 'Error');
          }
        );
      // }, 1000);
      

    };

    fetchData(offset);
  }
  
  private downloadExcel(leadItems: any[]): void {
    const modifiedLeadItems = leadItems.map(item => ({
      'Customer Name': item.first_name + ' ' + item.last_name,
      'Mobile No': item.mobile_number,
      'LOB': item.lob,
      'PPL': item.ppl,
      'PL': item.pl,
      'State': item.state,
      'City': item.city,
      'Registration Number': item.registration_number,
      'Created Date': this.datepipe.transform(item.created_at, 'dd-MM-yyyy hh:mm:ss a'),
  }));
  
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(modifiedLeadItems);
    const columnCount = Object.keys(modifiedLeadItems[0]).length;
    const columnWidths = Array(columnCount).fill({ wch: 30 }); 
  
    worksheet['!cols'] = columnWidths;
  
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };
  
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
 
    this.saveAsExcelFile(excelBuffer, `SalesEnquiryData`);
  }
  
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }  
}

export class ListInput {

  chassis_number: string;
  vc_number: string;
  lob: string;
  from_date: string;
  to_date: string;
  distributor_code: string;
  customer_type: string;
  offset: number;
  organization_name: string;
  vehicle_application: string
  source_of_contact: string;
  lead_id: string;
  opty_id: string;
  full_name: string;
  last_name: string;
  mobile_no: string;
  state: string;
  district: string;
  city: string;
  // vehicle_application: string;
  limit: number;
  lead_source:string;
  cat_id:any;
  lead_stage:string;
  mobile_number: string;
  registration_number: string;
}
export class inputData {
  mobile_number: string;
  limit: number;
  user_id: any;
  offset: number;
  text_search: string;
  visibility: string;
  state: string;
  max_odometer: number;
  min_odometer: number;
  city: string;
  district: string;
  minimum_budget: number;
  no_of_owners: string;
  region: string;
  expired: any;
  vehicle_category: string;
  vehicle_type: string;
  finance_availability: string;
  engine_warranty: string;
  emission: string;
  sub_cat_name:string;
  sub_cat_detail_name:string;
  lob:string;
  ppl:string;
  is_active:any;
  osp_is_active:any;
  cat_id:any;
  params_approval_status:any
  from_date:any;
  to_date:any;
  registration_number:any;
}